import $$ from "cmn-utils";

const baseUrl = "/api/sso/";

export default {
  shishi: (params) => {
    return $$.post(baseUrl + "shishi", params);
  },
  token: (params) => {
    return $$.get("/api/cas/sso/token", params);
  },
};
